import { toast } from 'react-toastify'

import { AuthAction } from '../../context/auth/types.ts'
import { ERROR_CODES } from '../../utils/errorCodes.ts'
import httpClient from '../httpClient.ts'
import {
  getAccessToken,
  getRefreshToken,
  getRefreshTokenTimestamp,
  handleTokenRefreshInResponse,
  isRefreshTokenValid
} from './tokens.ts'

export const showErrorToast = (message: string): void => {
  const toastId = toast.loading('Błąd')
  toast.update(toastId, {
    render: message,
    type: 'error',
    isLoading: false,
    autoClose: 3000
  })
}

export const extractErrorMessage = (errorData: any, code?: number): string => {
  if (code && ERROR_CODES[400]?.[code]) {
    return ERROR_CODES[400][code].descriptions.pl
  }

  const isExistsObject = Object.values(errorData).some(
    (value) => typeof value === 'object' && value !== null
  )

  if (isExistsObject) {
    for (const key of Object.keys(errorData)) {
      if (errorData[key]?.length > 0) {
        return errorData[key][0]
      }
    }
  }

  const isExistsMessage =
    Object.values(errorData).length > 0 &&
    typeof Object.values(errorData)[0] === 'string'

  if (isExistsMessage) {
    const message = Object.values(errorData)[0] as string
    return message.replace('null', '')
  }

  return 'Błąd z serwera'
}

export const handle400Error = (error: any): void => {
  const code = error.response.data.error_code as number
  console.log('400 error: ', code)
  const message = extractErrorMessage(error.response.data, code)
  showErrorToast(message)
}

export const handle403Error = (error: any): void => {
  const message = error.response.data.detail ?? 'Błąd serwera'
  showErrorToast(message)
}

export const handle500Error = (error: any): void => {
  console.log('500 error: ', error.response)
  toast.error('Błąd serwera! Spróbuj później')
}

export const handle401Error = async (
  error: any,
  dispatch?: React.Dispatch<AuthAction>
): Promise<any> => {
  if (error.config.url?.includes('token/refresh/')) {
    if (dispatch) {
      dispatch({ type: 'LOGOUT' })
    }
    return Promise.reject(error)
  }

  const refreshToken = getRefreshToken()
  const refreshTokenTimestamp = getRefreshTokenTimestamp()

  if (refreshToken && isRefreshTokenValid(refreshTokenTimestamp)) {
    try {
      await handleTokenRefreshInResponse()
      const newToken = getAccessToken()
      const originalRequest = error.config
      originalRequest.headers.Authorization = `Bearer ${newToken}`
      return httpClient.request(originalRequest)
    } catch {
      if (dispatch) {
        dispatch({ type: 'LOGOUT' })
      }
    }
  } else {
    if (dispatch) {
      dispatch({ type: 'LOGOUT' })
    }
  }

  return Promise.reject(error)
}
